import React from 'react'
import { List, useTable, EditButton, DeleteButton } from '@refinedev/antd'
import { Space, Table } from 'antd'

import { IProvider } from 'src/modules/SupplyContracts/Providers/Providers.d'

/**
 * This function returns a list of providers.
 *
 * @returns List of providers.
 */
export const ListProviders = () => {
    const { tableProps } = useTable<IProvider>({
        meta: {
            operation: 'allProviders',
            fields: [
                'totalCount',
                {
                    edges: [
                        {
                            node: ['id', 'name'],
                        },
                    ],
                },
            ],
        },
        sorters: {
            initial: [
                {
                    field: 'id',
                    order: 'asc',
                },
            ],
        },
    })

    return (
        <div>
            <List breadcrumb={null}>
                <Table
                    {...tableProps}
                    pagination={{
                        ...tableProps.pagination,
                        position: ['bottomRight'],
                        size: 'small',
                    }}
                    rowKey="id"
                >
                    <Table.Column dataIndex="name" title="Nom Fournisseur" sorter />
                    <Table.Column<IProvider>
                        title="Actions"
                        dataIndex="actions"
                        render={(_, record) => (
                            <Space>
                                <EditButton hideText size="small" recordItemId={record.id} />
                                <DeleteButton hideText size="small" recordItemId={record.id} />
                            </Space>
                        )}
                    />
                </Table>
            </List>
        </div>
    )
}
